export const companyInfo = {
  name: "Hovendals ApS",
  shortName: "Hovendals",
  founder: "Simon Hovendal",
  address: "Brandsbyvej 12, 5450 Otterup",
  phone: "40 55 55 99",
  phoneFormatted: "+4540555599",
  email: "mail@hovendals.dk",
  cvr: "43598953",
  facebook: "https://www.facebook.com/www.hovendals.dk/",
  logo: "/_assets/hovendals-logo.webp",
  logoBlack: "/_assets/hovendals-logo.webp",
  logoLarge: "/_assets/hovendals-logo.webp",
  favicon: "/_assets/favicon.png",
  slogan: "Vi bygger tillid og leverer resultater",
  heroVideo: "/_assets/hero-hovendals.mp4",
  heroPoster: "/_assets/hovendals-video-poster.jpg",
};

export const reviews = [
  {
    author: "Berit",
    title: "Vores bedste anbefaling",
    text: "Vi har haft Simon til at lave komposithegn som erstatning for andet hegn på vores terrasse. Vi er ovenud tilfreds med det arbejde han har udført. Den lille tillægsopgave han fik undervejs, blev også lavet til stor tilfredshed. Vi kan kun give Simon vores bedste anbefalinger med på vejen. En ung mand med mange talenter, der absolut også ved hvad god kundeservice er.",
    rating: 5,
  },
  {
    author: "Johnny Kajberg",
    title: "5 af 5 stjerner",
    text: "5 af 5 stjerner. Med ønsket om nyt vedligeholdelsesfrit hegn om grunden blev Hovendals kontaktet. Hurtig tilbagemelding med tilbud og referencesteder. God dialog frem til etableringstidspunktet. Fantastisk sparring for at få alle vores ønsker opfyldt. Faglig dygtig og kompetent håndværker, der kun er tilfreds med at aflevere det bedste udførte resultat. Vi kan varmt anbefale Simon/Hovendals",
    rating: 5,
  },
  {
    author: "Poul Erik Dyrlund",
    title: "Kan stærkt anbefale Hovendals",
    text: "Hovendals. Jeg kan stærkt anbefale ovenstående firma. En utrolig dygtig ung mand, der holder hvad han lover. Vi fik sat vedligeholdelsesfrit hegn op. Alt er lige og perfekt. Tak til Simon Hovendals",
    rating: 5,
  },
  {
    author: "John Munk Pedersen",
    title: "Kan ikke gøres bedre. Punktum!",
    text: "På en skala 1-10 et rent 12-tal. Vi reagerede på en anbefaling på facebook, og vi blev kun positivt overraskede. Hurtig tilbagemelding med tilbud, og færdiggørelse før vi havde forventet. Faktura der matcher tilbud på trods af lidt ekstraarbejder. Simon er utrolig tillidsvækkende. DET KAN IKKE GØRES BEDRE. PUNKTUM!",
    rating: 5,
  },
  {
    author: "Karin Olesen",
    title: "Min allerbedste anmeldelse til Hovendals",
    text: "Jeg vil gerne give mine allerbedste anmeldelse til Hovendals, for det flotte komposithegn der er lavet på min terrasse. Simon er en dygtig, behagelig og omhyggelig håndværker, man kan tænke sig. Jeg er ikke i tvivl om, at jeg en anden gang vil kontakte Simon, hvis jeg har andet jeg skal have lavet professionelt. Helt klart et 12-tal med pil op, og vil på det kraftigste anbefale Hovendals til enhver tid.",
    rating: 5,
  },
];

export const projects = [
  {
    slug: "nyheder-indhegning-af-erhvervsgrund-vejle",
    path: "/nyheder/indhegning-af-erhvervsgrund-vejle",
    title: "Indhegning af erhvervsgrund - Vejle",
    category: "Erhverv",
    date: "16 oktober, 2025",
    mainImage: "/_assets/thumbnail-1000003866-0.jpg",
    gallery: [
      "/_assets/thumbnail-1000003866-0.jpg",
      "/_assets/thumbnail-1000003872.jpg",
      "/_assets/thumbnail-1000003902-0.jpg",
    ],
    specs: [
      "Panelhegn galvaniseret",
      "Ca 350 meter med skydeport",
    ],
    description: "Specifikationer:\n- Panelhegn galvaniseret\n- Ca 350 meter med skydeport",
    metaTitle: "Indhegning af erhvervsgrund - Vejle | Hovendals",
    metaDesc: "Specifikationer: Panelhegn galvaniseret Ca 350 meter med skydeport",
  },
  {
    slug: "nyheder-staalcarport-med-tilhoerende-skur-boerkop",
    path: "/nyheder/staalcarport-med-tilhoerende-skur-boerkop",
    title: "Stålcarport med tilhørende skur - Børkop",
    category: "Privat",
    date: "16 oktober, 2025",
    mainImage: "/_assets/thumbnail-img20250813100319-1.jpg",
    gallery: [
      "/_assets/thumbnail-img20250813100319-1.jpg",
      "/_assets/thumbnail-img20250813095918-1.jpg",
      "/_assets/thumbnail-img20250813100327-1.jpg",
    ],
    specs: [
      "Termotag",
      "Galvaniseret stål konstruktion",
      "Kompositbeklædning",
      "6 x 6 meter",
    ],
    description: "Specifikationer:\n- Termotag\n- Galvaniseret stål konstruktion\n- Kompositbeklædning\n- 6 x 6 meter",
    metaTitle: "Stålcarport med tilhørende skur - Børkop | Hovendals",
    metaDesc: "Specifikationer: Termotag Galvaniseret stål konstruktion Kompositbeklædning 6 x 6 meter",
  },
  {
    slug: "nyheder-indhegning-af-sommerhus-hasmark",
    path: "/nyheder/indhegning-af-sommerhus-hasmark",
    title: "Indhegning af sommerhus - Hasmark",
    category: "Privat",
    date: "16 oktober, 2025",
    mainImage: "/_assets/thumbnail-img20250423152704.jpg",
    gallery: [
      "/_assets/thumbnail-img20250423152704.jpg",
      "/_assets/thumbnail-1000003477.jpg",
    ],
    specs: [
      "Antrcit betonstolper med pine brunimprægnieret træ fag",
      "Tilhørende skydeport i galvaniseret stål",
    ],
    description: "Specifikationer:\n- Antrcit betonstolper med pine brunimprægnieret træ fag\n- Tilhørende skydeport i galvaniseret stål",
    metaTitle: "Indhegning af sommerhus - Hasmark | Hovendals",
    metaDesc: "Specifikationer: Antrcit betonstolper med pine brunimprægnieret træ fag Tilhørende skydeport i galvaniseret stål",
  },
  {
    slug: "nyheder-forskellige-projekter-rema-1000",
    path: "/nyheder/forskellige-projekter-rema-1000",
    title: "Forskellige projekter for Rema 1000",
    category: "Erhverv",
    date: "16 oktober, 2025",
    mainImage: "/_assets/thumbnail-1000002740.jpg",
    gallery: [
      "/_assets/thumbnail-1000002740.jpg",
      "/_assets/thumbnail-1000002629.jpg",
      "/_assets/thumbnail-1000003289.jpg",
      "/_assets/thumbnail-1000003366.jpg",
      "/_assets/thumbnail-img20240208111238.jpg",
      "/_assets/thumbnail-img20250717075857_a7172fc7.jpg",
    ],
    specs: [
      "Indhegning af varegård",
      "Gelænder",
      "Trappe med rapo",
    ],
    description: "Vi har uderført forskellige projekter for rema.\n\nIndhegning af varegård, gelænder, trappe med rapo.",
    metaTitle: "Forskellige projekter for Rema 1000 | Hovendals",
    metaDesc: "Vi har uderført forskellige projekter for rema. Indhegning af varegård, gelænder, trappe med rapo.",
  },
  {
    slug: "nyheder-carport-med-skur-tommerup",
    path: "/nyheder/carport-med-skur-tommerup",
    title: "Carport med skur - Tommerup",
    category: "Privat",
    date: "3 september, 2025",
    mainImage: "/_assets/thumbnail-1000004137.jpg",
    gallery: [
      "/_assets/thumbnail-1000004137.jpg",
      "/_assets/thumbnail-1000004142-1.jpg",
      "/_assets/thumbnail-1000004143.jpg",
    ],
    specs: [
      "Galvaniseret stål stolper",
      "Ståltag",
      "Hardieplank på stern",
      "Træ spær",
      "Komposit som beklædning",
    ],
    description: "Specifikationer:\n- Galvaniseret stål stolper.\n- Ståltag.\n- Hardieplank på stern.\n- Træ spær.\n- Komposit som beklædning.",
    metaTitle: "Carport med skur - Tommerup | Hovendals",
    metaDesc: "Specifikationer Galvaniseret stål stolper. Ståltag. Hardieplank på stern. Træ spær. Komposit som beklædning.",
  },
  {
    slug: "nyheder-nyt-vaern",
    path: "/nyheder/nyt-vaern",
    title: "Nyt Værn",
    category: "Erhverv",
    date: "3 september, 2025",
    mainImage: "/_assets/490998393-1332557881565742-7583348290595987841-n.jpg",
    gallery: [
      "/_assets/490998393-1332557881565742-7583348290595987841-n.jpg",
    ],
    specs: [
      "Hurtig levering og montering efter påkørsel",
      "Sikkerheden på rampen genetableret for både personale og chauffører",
      "Risikoen for ulykker og skader er minimeret",
      "Værnet er udført i solide materialer, der tåler hårdt slid",
      "En holdbar løsning, der sikrer både tryghed og driftssikkerhed",
    ],
    description: "REMA 1000 i Odense oplevede en påkørsel af et værn ved deres rampeområde. For at sikre hurtig genopretning leverede og monterede vi et nyt værn i løbet af ganske kort tid\n\nProjekt: Nyt værn hos REMA 1000 i Odense\n\nMed den nye løsning kan både personale og chauffører igen færdes sikkert på rampen, og risikoen for ulykker er minimeret. Værnet er udført i solide materialer, der kan modstå hårdt slid og daglig belastning – en investering i både tryghed og driftssikkerhed.",
    metaTitle: "Nyt Værn | Hovendals",
    metaDesc: "REMA 1000 i Odense oplevede en påkørsel af et værn ved deres rampeområde. For at sikre hurtig genopretning leverede og monterede vi et nyt værn i løbet af ganske kort tid",
  },
  {
    slug: "nyheder-hegn-til-privat-have",
    path: "/nyheder/hegn-til-privat-have",
    title: "Hegn til privat have",
    category: "Privat",
    date: "3 september, 2025",
    mainImage: "/_assets/485170711-1308137817341082-5036954073090041011-n-0.jpg",
    gallery: [
      "/_assets/485170711-1308137817341082-5036954073090041011-n-0.jpg",
    ],
    specs: [
      "Bygget i robuste materialer, der tåler det danske klima",
      "Flot og funktionelt hegn, der skaber privatliv og tryghed",
      "Minimal vedligeholdelse – kun almindelig rengøring efter behov",
    ],
    description: "Kundens ønske: Kunden ønskede et nyt hegn omkring haven for at skabe mere privatliv, øge trygheden og samtidig give ejendommen et pænere udtryk mod vejen.\n\nVores løsning:\n- Bygget i robuste materialer, der tåler det danske klima\n\nResultatet:\n- Et flot og funktionelt hegn, der skaber privatliv og tryghed\n- Æstetisk løsning, der løfter helhedsindtrykket af haven og ejendommen\n- Minimal vedligeholdelse – kun almindelig rengøring efter behov\n- En holdbar konstruktion designet til at stå stærkt i mange år fremover",
    metaTitle: "Hegn til privat have | Hovendals",
    metaDesc: "Kundens ønske Kunden ønskede et nyt hegn omkring haven for at skabe mere privatliv, øge trygheden og samtidig give ejendommen et pænere udtryk mod vejen.",
  },
];

export const mainServices = [
  {
    title: "Hegn",
    href: "/hegn",
    image: "/_assets/komposithegn-laage.webp",
    desc: "Komposithegn, panelhegn, smedejernshegn, støjhegn, rionet, betonhegn og træbeklædt hegn i høj kvalitet.",
    sublinks: [
      { label: "Komposithegn", href: "/komposithegn" },
      { label: "Industrihegn", href: "/industrihegn" },
      { label: "Støjhegn", href: "/stoejhegn" },
      { label: "Panelhegn", href: "/panelhegn" },
      { label: "Smedejernshegn", href: "/smedejernshegn" },
      { label: "Rionet", href: "/rionet" },
      { label: "Betonhegn", href: "/betonhegn" },
      { label: "Træbeklædt hegn", href: "/traebeklaedt-hegn-et-naturligt-valg" },
    ],
  },
  {
    title: "Låger",
    href: "/laager",
    image: "/_assets/thumbnail-img20250716165143.jpg",
    desc: "Funktionalitet og æstetik i én løsning – kompositlåger, smedejernslåger, panellåger, rionetlåger og træbeklædte låger.",
    sublinks: [
      { label: "Kompositlåge", href: "/kompositlaage" },
      { label: "Kompositdør", href: "/kompositdor" },
      { label: "Panellåge", href: "/panellaage" },
      { label: "Rionetlåge", href: "/rionetlaage" },
      { label: "Smedejernslåge", href: "/smedejernslaage" },
      { label: "Træbeklædte låger", href: "/traebeklaedte-laager" },
    ],
  },
  {
    title: "Porte",
    href: "/porte",
    image: "/_assets/foldeport.webp",
    desc: "Sikkerhed og design i samme løsning. Vi leverer både skydeporte, dobbeltporte og foldeporte til private og erhverv.",
    sublinks: [
      { label: "Skydeporte", href: "/skydeporte" },
      { label: "Dobbeltporte", href: "/dobbeltporte" },
      { label: "Foldeporte", href: "/foldeporte-i-funktionelt-design" },
    ],
  },
  {
    title: "Terrasser",
    href: "/terrasser",
    image: "/_assets/glashegn.webp",
    desc: "Terrasseløsninger med fokus på funktionalitet, kvalitet og et flot udtryk tilpasset din bolig.",
    sublinks: [
      { label: "Terrasser", href: "/terrasser" },
      { label: "Glasafskærmning", href: "/terrasser" },
    ],
  },
  {
    title: "Carport",
    href: "/carport",
    image: "/_assets/carport-skur.webp",
    desc: "Beskyttelse og æstetik i ét – enkle eller dobbelte stålcarporte med eller uden integreret redskabsskur.",
    sublinks: [
      { label: "Carport løsninger", href: "/carport" },
      { label: "Skur", href: "/skur" },
    ],
  },
  {
    title: "Skur",
    href: "/skur",
    image: "/_assets/thumbnail-1000004145-0.jpg",
    desc: "Praktisk opbevaring i flot design. Skræddersyede løsninger i robuste, vedligeholdelsesfri materialer.",
    sublinks: [
      { label: "Læs om skure", href: "/skur" },
      { label: "Galleri: Skur", href: "/galleri/skur" },
    ],
  },
  {
    title: "Facader & Vinduer",
    href: "/facader",
    image: "/_assets/hovendals-facade.jpg",
    desc: "Et flot og holdbart udtryk tilpasset dine ønsker og bygningens arkitektur.",
    sublinks: [
      { label: "Facadeløsninger", href: "/facader" },
      { label: "Vinduespartier", href: "/vinduespartier" },
    ],
  },
];

export const curatedShowcaseProjects = [
  {
    title: "Komposithegn og låge",
    category: "Komposithegn & Låger",
    image: "/_assets/komposithegn-laage.webp",
    desc: "Mørkegråt komposithegn med matchende låge udført foran moderne bolig.",
    link: "/komposithegn"
  },
  {
    title: "Betonhegn og skydeport",
    category: "Hegn & Porte",
    image: "/_assets/sommerhus-betonhegn-skydeport.webp",
    desc: "Lyst hegn med integreret port monteret ved sommerhus.",
    link: "/betonhegn"
  },
  {
    title: "Industrihegn og adgangsport",
    category: "Erhverv & Industri",
    image: "/_assets/industrihegn-02.webp",
    desc: "Galvaniseret industrihegn og adgangsport foran større erhvervsbygning.",
    link: "/industrihegn"
  },
  {
    title: "Dobbeltport med trådgitter",
    category: "Porte",
    image: "/_assets/dobbeltport-01.webp",
    desc: "Stor galvaniseret metalport udført til indhegnet erhvervsområde.",
    link: "/dobbeltporte"
  },
  {
    title: "Foldeport i træ og stål",
    category: "Porte",
    image: "/_assets/foldeport.webp",
    desc: "Bred foldeport med træfarvede felter i stålrammer ved privat ejendom.",
    link: "/foldeporte-i-funktionelt-design"
  },
  {
    title: "Carport og skur",
    category: "Carporte & Skure",
    image: "/_assets/carport-skur.webp",
    desc: "Moderne carport- og skurkonstruktion i slidstærkt stål.",
    link: "/carport"
  },
  {
    title: "Glashegn til terrasse",
    category: "Terrasser & Afskærmning",
    image: "/_assets/glashegn.webp",
    desc: "Terrasse med elegant glasafskærmning og udsigt til det åbne landskab.",
    link: "/terrasser"
  },
  {
    title: "Panelhegn ved have",
    category: "Panelhegn",
    image: "/_assets/panelhegn.webp",
    desc: "Stilrent panelhegn ved privat have og bolig.",
    link: "/panelhegn"
  },
  {
    title: "Udestue og overdækning",
    category: "Udestuer & Terrasser",
    image: "/_assets/udestue.webp",
    desc: "Glasinddækket udestue med lyst tag og integreret terrasse.",
    link: "/facader"
  }
];
